import React, { useCallback } from "react";
import { useTranslations } from "@src/packages/i18n";
import { useBasicInfo } from "../BasicInfoContext";
import { BasicInfoQuestionLayout, YesNoOptions } from "../components";
import { useNavigation } from "@react-navigation/native";
import { usePatient } from "@src/packages/patients/hooks/usePatient";
import { useQueuedPatientUpdate } from "@src/packages/patients/sync/usePatientSync";

export function AllergiesScreen() {
  const t = useTranslations();
  const { state, updateState, next } = useBasicInfo("Allergies");
  const navigation = useNavigation();
  const { data: patient } = usePatient();
  const { mutateAsync: updatePatient, isPending } = useQueuedPatientUpdate();

  const selection = state.hasAllergies ?? null;

  const handleSelection = useCallback(
    async (value: boolean) => {
      const stateUpdates = { hasAllergies: value };
      updateState(stateUpdates);
      try {
        await updatePatient({
          medicalHistory: {
            id: patient?.medicalHistory?.id,
            hasAllergies: value,
          },
        });
      } catch {
        return;
      }

      if (selection === null) {
        next(stateUpdates);
      }
    },
    [next, selection, updateState, updatePatient, patient?.medicalHistory?.id],
  );

  return (
    <BasicInfoQuestionLayout
      route="Allergies"
      title={t("med_history.basic_info.allergies.title")}
      helpText={t("med_history.basic_info.help.allergies")}
      onBack={() => navigation.goBack()}
      onSave={() => next()}
      saveDisabled={selection === null || isPending}
      hideSaveButton={selection === null}
      saveLabel={t("med_history.shared.next")}
    >
      <YesNoOptions
        noLabel={t("med_history.shared.no")}
        onChange={handleSelection}
        value={selection}
        yesLabel={t("med_history.shared.yes")}
      />
    </BasicInfoQuestionLayout>
  );
}

export default AllergiesScreen;
